<script setup lang="ts"></script>

<template lang="pug">
.ui-loader.flex-center-center.h-100p
  svg.dot.dot-small(width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg")
    path(fill-rule="evenodd" clip-rule="evenodd" d="M4.5 6.5C3.11929 6.5 2 5.38071 2 4C2 2.61929 3.11929 1.5 4.5 1.5C5.88071 1.5 7 2.61929 7 4C7 5.38071 5.88071 6.5 4.5 6.5Z" fill="currentColor")
  svg.dot.dot-ring(width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg")
    path(fill-rule="evenodd" clip-rule="evenodd" d="M8.5 4.42857C6.52755 4.42857 4.92857 6.02755 4.92857 8C4.92857 9.97245 6.52755 11.5714 8.5 11.5714C10.4724 11.5714 12.0714 9.97245 12.0714 8C12.0714 6.02755 10.4724 4.42857 8.5 4.42857ZM3.5 8C3.5 5.23858 5.73858 3 8.5 3C11.2614 3 13.5 5.23858 13.5 8C13.5 10.7614 11.2614 13 8.5 13C5.73858 13 3.5 10.7614 3.5 8Z" fill="currentColor")
  svg.dot.dot-small(width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg")
    path(fill-rule="evenodd" clip-rule="evenodd" d="M4.5 6.5C3.11929 6.5 2 5.38071 2 4C2 2.61929 3.11929 1.5 4.5 1.5C5.88071 1.5 7 2.61929 7 4C7 5.38071 5.88071 6.5 4.5 6.5Z" fill="currentColor")
</template>

<style scoped>
.ui-loader {
  .dot {
    flex-shrink: 0;
  }

  .dot-small {
    width: var(--button-loader-dot-size, 8px);
    height: var(--button-loader-dot-size, 8px);
  }

  .dot-ring {
    width: var(--button-loader-ring-size, 16px);
    height: var(--button-loader-ring-size, 16px);
  }

  .dot:nth-last-child(1) {
    animation: jumpingAnimation 1.2s 0.6s linear infinite;
  }
  .dot:nth-last-child(2) {
    animation: jumpingAnimation 1.2s 0.3s linear infinite;
  }
  .dot:nth-last-child(3) {
    animation: jumpingAnimation 1.2s 0s linear infinite;
  }
}

@keyframes jumpingAnimation {
  0% {
    transform: translate(0, 0);
  }
  16% {
    transform: translate(0, -4px);
  }
  33% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(0, 0);
  }
}
</style>
